import { isNil, isObject } from "./General";
import { toCrazySnakeCase } from "./String";

function generateReduxActionTypes(config) {
  const actionTypes = {};

  Object.keys(config).forEach((configKey) => {
    const snakeCaseKey = toCrazySnakeCase(configKey);
    actionTypes[snakeCaseKey] = snakeCaseKey;
  });

  return actionTypes;
}

function generatePayloadFromConfig(config, params) {
  const payload = {};

  for (let i = 0; i < config.length; i += 1) {
    const configKey = config[i];
    payload[configKey] = params[i];
  }

  return payload;
}

function generateReduxActions(config) {
  const actions = {};

  Object.keys(config).forEach((configKey) => {
    const actionConfig = config[configKey];
    if (isNil(actionConfig)) {
      actions[configKey] = () => ({ type: toCrazySnakeCase(configKey) });
    } else if (Array.isArray(actionConfig)) {
      actions[configKey] = (...params) => ({
        type: toCrazySnakeCase(configKey),
        payload: generatePayloadFromConfig(actionConfig, params),
      });
    } else {
      throw new Error(`Couldn't understand config of ${configKey}`);
    }
  });

  return actions;
}

export function createActions(config) {
  return {
    types: generateReduxActionTypes(config),
    actions: generateReduxActions(config),
  };
}

export function createReducer(initialState, handlers) {
  if (isNil(initialState)) {
    throw new Error("Initial state is required");
  }

  if (!isObject(handlers)) {
    throw new Error("Handlers need to be an object");
  }

  return (state = initialState, action) => {
    if (!action.type) {
      return state;
    }

    const handler = handlers[action.type];

    if (handler === undefined) {
      return state;
    }

    return handler(state, action);
  };
}
